import { MyForm } from '~/components/ui/MyForm'
import { QuestionCircleOutlined } from '@ant-design/icons'
import styles from '../AiForm.module.css'
import GridSelect from '../GridSelect'
import { optionsAtom, selectSamplerAtom } from './atom'
import { useAtom } from 'jotai'
import classNames from 'classnames'
import { Tooltip } from 'antd'
import { getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_samplerOptions } from '~/graphqls/types'

export const SamplerComp: React.FC<{
  disabled: boolean
}> = ({ disabled = false }) => {
  const [options] = useAtom(optionsAtom)
  const [selectSampler, setSelectSampler] = useAtom(selectSamplerAtom)

  return (
    <MyForm.Item
      className={classNames(styles.borderLessFormItem, '!mb-3')}
      label={
        <span>
          采样模式{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="采样模式（Sampler）是指扩散去噪算法的采样模式，如果设置正确，它们会发散并最终收敛"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
    >
      <GridSelect
        placeholder="请选择采样模式"
        options={
          options?.samplerOptions as getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_samplerOptions[]
        }
        max={1}
        value={selectSampler}
        disabled={disabled}
        onChange={(val: any) => setSelectSampler(val)}
      />
    </MyForm.Item>
  )
}
